<template>
  <v-btn
    class="cursor-pointer"
    prepend-icon="mdi-content-copy"
    @click="copyToClipboard"
    variant="elevated"
    size="large"
    color="primary"
    >{{ copyStatus ? copyStatus : `Copy ${label}` }}</v-btn
  >
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  label: string
  contentToCopy: string
}>()

const copyStatus = ref('')

// Copy embed code to clipboard
const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(props.contentToCopy)
    copyStatus.value = 'Copied to clipboard!'

    // Reset the icon and status after 2 seconds
    setTimeout(() => {
      copyStatus.value = ''
    }, 2000)
  } catch (err) {
    copyStatus.value = 'Failed to copy text'
    console.error('Failed to copy text:', err)
  }
}
</script>

<style scoped>
.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin: 0;
  vertical-align: middle;
}
</style>
